import styled from 'styled-components';
import { spaceMixin } from '@zillow/constellation';

export const StyledSpinnerContainer = styled.div`
    text-align: center;
    padding: ${spaceMixin(8)};
`;
